module.exports = __webpack_public_path__ + "img/title.29c8c8b8.jpg";